import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 탈리 획 — 한 획은 데이터 한 건(기록 1건, 하루 1일, 탭 1번)이다. 장식으로 쓰지 않는다.
 * 다섯 획이 모이면 正 한 자가 된다(一 → 丨 → 짧은 一 → 왼쪽 丨 → 아래 一).
 */
const STROKES = [
    'M2 2 H18',
    'M10 2 V18',
    'M10 10 H16',
    'M4.5 9 V18',
    'M1 18 H19',
];
export function TallyGroup({ strokes, size = 20 }) {
    const shown = Math.max(0, Math.min(5, Math.floor(strokes)));
    return _jsx("svg", { className: "ng-tally-group", width: size, height: size, viewBox: "0 0 20 20", "aria-hidden": true, children: STROKES.map((d, index) => _jsx("path", { d: d, className: index < shown ? 'is-on' : 'is-off' }, d)) });
}
/** count개의 획을 正 묶음으로 그린다. 많으면 max 묶음까지 그리고 숫자를 함께 쓴다. */
export function Tally({ count, label, size = 18, maxGroups = 4, showNumber = false }) {
    const safe = Math.max(0, Math.floor(count));
    const groups = Math.min(maxGroups, Math.ceil(safe / 5));
    const overflow = safe > maxGroups * 5;
    return _jsxs("span", { className: "ng-tally", role: "img", "aria-label": `${label} ${safe}`, children: [Array.from({ length: groups }, (_, index) => _jsx(TallyGroup, { size: size, strokes: Math.min(5, safe - index * 5) }, index)), safe === 0 ? _jsx("span", { className: "ng-tally-empty", "aria-hidden": true, children: "\u00B7" }) : null, showNumber || overflow ? _jsx("b", { "aria-hidden": true, children: safe }) : null] });
}
